import TextEpisode from './TextEpisode'

export default TextEpisode
// eslint-disable-next-line import/export
export * from './TextEpisode'
